(function () {
  'use strict';

  var SCROLL_OFFSET = 96;
  var PRODUCT_NAV_GRACE_MS = 90000;
  var REVIEW_HASHES = ['#iuh-product-reviews', '#judgeme_product_reviews'];

  function getReviewRoot() {
    return document.getElementById('iuh-product-reviews');
  }

  function getReviewTarget() {
    var root = getReviewRoot();
    if (root) {
      var toolbar = root.querySelector('.jdgm-toolbar');
      if (toolbar && !toolbar.hidden) return toolbar;
      var wrap = root.querySelector('.jdgm-grid-wrap');
      if (wrap) return wrap;
      return root;
    }
    var grid = document.querySelector('[data-jdgm-grid]');
    if (grid) return grid.closest('#iuh-product-reviews') || grid;
    return document.getElementById('judgeme_product_reviews');
  }

  function scrollToReviews(behavior) {
    var el = getReviewTarget();
    if (!el) return false;
    window.__iuhScrollToReviewsUntil = Date.now() + 4000;
    var top = el.getBoundingClientRect().top + window.pageYOffset - SCROLL_OFFSET;
    window.scrollTo({ top: Math.max(0, top), behavior: behavior || 'smooth' });
    return true;
  }

  function retryScrollToReviews() {
    [400, 900, 1800].forEach(function (ms) {
      setTimeout(function () {
        if (!getReviewRoot()) return;
        scrollToReviews(ms === 1800 ? 'auto' : 'smooth');
      }, ms);
    });
  }

  function isReviewBadgeClick(target) {
    if (!target || !target.closest) return null;
    var productRoot = document.querySelector('[data-section-type="product"]');
    if (!productRoot) return null;
    var hit = target.closest(
      '.jdgm-prev-badge__stars, .jdgm-prev-badge__text, .jdgm-prev-badge__wrapper, ' +
      '.jdgm-preview-badge__link, .jdgm-preview-badge, .jdgm-widget.jdgm-preview-badge, ' +
      '.shopify-product-reviews-badge, .review .jdgm-widget, ' +
      'a[href="#judgeme_product_reviews"], a[href="#iuh-product-reviews"]'
    );
    if (!hit || !productRoot.contains(hit)) return null;
    if (hit.closest('[data-jdgm-grid], #iuh-product-reviews, .jdgm-grid-wrap, .jdgm-grid-area')) return null;
    return hit;
  }

  function handleReviewNav(e) {
    if (!document.querySelector('.product-form, [data-section-type="product"]')) return;
    var badge = isReviewBadgeClick(e.target);
    if (!badge) return;
    if (scrollToReviews('smooth')) {
      retryScrollToReviews();
      if (e.preventDefault) e.preventDefault();
      if (e.stopPropagation) e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    }
  }

  function bindReviewBadgeScroll() {
    document.addEventListener('click', handleReviewNav, true);
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      handleReviewNav(e);
    }, true);

    window.addEventListener('hashchange', function () {
      if (REVIEW_HASHES.indexOf(window.location.hash) === -1) return;
      scrollToReviews('smooth');
      retryScrollToReviews();
      history.replaceState(null, '', window.location.pathname + window.location.search);
    });

    if (REVIEW_HASHES.indexOf(window.location.hash) !== -1) {
      scrollToReviews('auto');
      retryScrollToReviews();
      history.replaceState(null, '', window.location.pathname + window.location.search);
    }
  }

  function bindVariantSelectHelpers() {
    document.querySelectorAll('.product-form__item').forEach(function (wrap) {
      var select = wrap.querySelector('select.single-option-selector');
      if (!select) return;
      wrap.querySelectorAll('.js-swatch-display, label[for="' + select.id + '"]').forEach(function (el) {
        el.style.cursor = 'pointer';
        el.addEventListener('click', function () {
          select.focus();
          try {
            if (typeof select.showPicker === 'function') select.showPicker();
          } catch (err) { /* unsupported */ }
        });
      });
    });

    document.querySelectorAll('.single-option-radio label').forEach(function (label) {
      label.style.cursor = 'pointer';
    });
  }

  function bindAvailableVariantFallback() {
    var form = document.querySelector('.product-form');
    var jsonEl = document.querySelector('[id^="ProductJson-"]');
    if (!form || !jsonEl) return;

    var product;
    try { product = JSON.parse(jsonEl.textContent); } catch (err) { return; }

    form.addEventListener('change', function (e) {
      var input = e.target;
      if (!input.matches('.single-option-selector__radio')) return;

      var selected = Array.prototype.map.call(
        form.querySelectorAll('.single-option-selector__radio:checked'),
        function (radio) { return radio.value; }
      );
      var exact = product.variants.find(function (variant) {
        return variant.options.every(function (value, index) { return value === selected[index]; });
      });
      if (!exact || exact.available) return;

      var changedIndex = Number(input.dataset.index.replace('option', '')) - 1;
      var fallback = product.variants.find(function (variant) {
        return variant.available && variant.options[changedIndex] === input.value;
      });
      if (!fallback) return;

      fallback.options.forEach(function (value, index) {
        var radios = form.querySelectorAll(
          '.single-option-selector__radio[data-index="option' + (index + 1) + '"]'
        );
        Array.prototype.forEach.call(radios, function (radio) {
          radio.checked = radio.value === value;
        });
        var sticky = document.getElementById('js-sticky-option-' + (index + 1));
        if (sticky) sticky.value = value;
      });
    }, true);
  }

  function bindShippingTimeline() {
    document.querySelectorAll('.shipping-timeline [data-shipping-tip]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var step = btn.closest('.timeline-step');
        var panel = btn.parentElement.querySelector('.shipping-timeline__tip');
        if (!panel) return;
        var open = panel.hidden;
        document.querySelectorAll('.shipping-timeline__tip').forEach(function (p) { p.hidden = true; });
        document.querySelectorAll('.timeline-step.is-tip-open').forEach(function (s) { s.classList.remove('is-tip-open'); });
        document.querySelectorAll('.shipping-timeline [data-shipping-tip]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
        if (open) {
          panel.hidden = false;
          btn.setAttribute('aria-expanded', 'true');
          if (step) step.classList.add('is-tip-open');
        }
      });
    });
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.shipping-timeline')) {
        document.querySelectorAll('.shipping-timeline__tip').forEach(function (p) { p.hidden = true; });
        document.querySelectorAll('.timeline-step.is-tip-open').forEach(function (s) { s.classList.remove('is-tip-open'); });
        document.querySelectorAll('.shipping-timeline [data-shipping-tip]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      }
    });
  }

  function bindGalleryZoomHint() {
    if (!document.querySelector('.product-form')) return;
    document.querySelectorAll('.product-single__photo img, .product__photo-wrapper').forEach(function (el) {
      el.style.cursor = 'zoom-in';
    });
  }

  function markProductBrowsing() {
    window.__iuhProductBrowseUntil = Date.now() + PRODUCT_NAV_GRACE_MS;
  }

  function bindProductBrowseGrace() {
    if (window.location.pathname.indexOf('/products/') !== 0) return;
    document.addEventListener('click', function (e) {
      var link = e.target.closest('a[href*="/products/"]');
      if (link) markProductBrowsing();
    });
    markProductBrowsing();
  }

  function enhanceFreeShippingProgress() {
    var currency = window.Shopify && window.Shopify.currency;
    if (!currency) return;
    var rate = (currency.active === 'EUR' || currency.active === 'USD') ? 1 : Number(currency.rate);
    var valid = Number.isFinite(rate) && rate > 0;
    document.querySelectorAll('.iuh-shipping-threshold').forEach(function (el) {
      if (!valid) {
        el.textContent = '€80';
        return;
      }
      var amount = Math.ceil(8000 * rate) / 100;
      var display = new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency', currency: currency.active, currencyDisplay: 'code'
      }).format(amount);
      el.textContent = (currency.active === 'EUR' || currency.active === 'USD') ? display : '≈ ' + display;
      el.title = currency.active === 'USD' ? 'Free shipping from US$80.' : '€80 minimum; currency conversion is finalized at checkout.';
    });
  }

  function initStickyAtc() {
    var form = document.querySelector('.product-form');
    var submit = form && form.querySelector('.product-form__cart-submit, [name="add"]');
    if (!form || !submit || window.matchMedia('(min-width: 990px)').matches) return;
    if (document.querySelector('.sticky-cart-wr')) return; // theme already has sticky ATC

    var bar = document.createElement('div');
    bar.className = 'iuh-sticky-atc';
    bar.innerHTML = '<div class="iuh-sticky-atc__inner"><span class="iuh-sticky-atc__price"></span><button type="button" class="btn btn-theme iuh-sticky-atc__btn"></button></div>';
    document.body.appendChild(bar);

    var priceEl = bar.querySelector('.iuh-sticky-atc__price');
    var btn = bar.querySelector('.iuh-sticky-atc__btn');
    var priceSource = document.querySelector('.product-single__price');
    btn.textContent = submit.textContent.trim() || 'Add to cart';
    if (priceSource) priceEl.textContent = priceSource.textContent.trim();

    btn.addEventListener('click', function () { submit.click(); });

    var observer = new IntersectionObserver(function (entries) {
      bar.classList.toggle('is-visible', !entries[0].isIntersecting);
    }, { threshold: 0 });
    observer.observe(submit);
  }

  function init() {
    if (!document.querySelector('[data-section-type="product"], .product-form')) return;
    bindReviewBadgeScroll();
    bindVariantSelectHelpers();
    bindAvailableVariantFallback();
    bindShippingTimeline();
    bindGalleryZoomHint();
    bindProductBrowseGrace();
    enhanceFreeShippingProgress();
    initStickyAtc();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
